import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import UserModule from '@/Store/modules/user'
import BarModule from '@/Store/modules/bar'
import DrawerModule from '@/Store/modules/drawer'
import UiModule from '@/Store/modules/ui'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState(),
  ],
  modules: {
    user: UserModule,
    bar: BarModule,
    drawer: DrawerModule,
    ui: UiModule,
  },
})
